import { Injectable } from '@angular/core';

@Injectable()
export class DataStorage {
  private static readonly storageName = 'wallscript';

  constructor() {}

  generateKey(key) {
    return DataStorage.storageName + '_' + key;
  }

  store(key, value) {
    const encryValue = btoa(JSON.stringify(value));
    localStorage.setItem(this.generateKey(key), encryValue);
  }

  get(key) {
    const encryValue = localStorage.getItem(this.generateKey(key));
    let value: any;
    if (encryValue) {
      value = JSON.parse(atob(encryValue));
    }
    return value;
  }

  remove(key) {
    //localStorage.setItem(this.generateKey(key), "");
    localStorage.removeItem(this.generateKey(key));
    localStorage.clear();
  }
}



// WEBPACK FOOTER //
// ./src/providers/data-storage/data-storage.ts